import { useEffect, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import "./BrandPartnerships.css";

gsap.registerPlugin(ScrollTrigger);

const BrandPartnerships = () => {
  const eyebrowRef = useRef(null);
  const titleRef = useRef(null);
  const dividerRef = useRef(null);
  const descRef = useRef(null);

  useEffect(() => {
    const lines = titleRef.current?.querySelectorAll(".brand-line");

    // Eyebrow fades in first
    gsap.from(eyebrowRef.current, {
      scrollTrigger: {
        trigger: eyebrowRef.current,
        start: "top 85%",
        toggleActions: "play none none reverse",
      },
      y: 20,
      opacity: 0,
      duration: 0.9,
      ease: "power3.out",
    });

    // Title lines stagger in from LEFT
    if (lines && lines.length) {
      gsap.from(lines, {
        scrollTrigger: {
          trigger: titleRef.current,
          start: "top 80%",
          toggleActions: "play none none reverse",
        },
        x: -80,
        opacity: 0,
        duration: 1.1,
        stagger: 0.12,
        ease: "power3.out",
      });
    }

    // Gold divider grows out
    gsap.from(dividerRef.current, {
      scrollTrigger: {
        trigger: dividerRef.current,
        start: "top 85%",
        toggleActions: "play none none reverse",
      },
      scaleX: 0,
      transformOrigin: "left center",
      duration: 1.2,
      delay: 0.3,
      ease: "power3.out",
    });

    // Description slides in from RIGHT
    gsap.from(descRef.current, {
      scrollTrigger: {
        trigger: descRef.current,
        start: "top 85%",
        toggleActions: "play none none reverse",
      },
      x: 80,
      opacity: 0,
      duration: 1.1,
      delay: 0.35,
      ease: "power3.out",
    });
  }, []);

  return (
    <section className="brand-section">
      <div className="brand-glow" aria-hidden="true" />

      <div className="brand-content">
        <span className="brand-eyebrow" ref={eyebrowRef}>
          Our Mission
        </span>

        <h1 className="brand-title" ref={titleRef}>
          <span className="brand-line">EMPOWERING VOICES</span>
          <span className="brand-line">IN ENTERTAINMENT</span>
          <span className="brand-line">AND BEYOND</span>
        </h1>

        <span className="brand-divider" ref={dividerRef} aria-hidden="true" />

        <p className="brand-description" ref={descRef}>
          LRM Management Inc. empowers artists through talent management, tour
          booking, show production, digital media, and brand strategy, guiding
          growth in career and legacy.
        </p>
      </div>
    </section>
  );
};

export default BrandPartnerships;
